import React, { FC } from 'react'
import { TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import {
  ResidentAppAsideText,
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { FeedbackDataLoader } from './FeedbackDataLoader'
import { FeedbackForm } from './FeedbackForm'
import { FeedbackSuccess } from './FeedbackSuccess'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'
import routePath from '../../router/routePath'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

export type FeedbackViewState = 'form' | 'preview' | 'success'

export const Feedback: FC = () => {
  const [view, setView] = React.useState<FeedbackViewState>('form')
  const { t } = useTranslation(['common', 'feedback', 'titles'])
  const { frontPagePath } = useContractPaths()
  const location = useLocation()
  const locationState = location.state as { from: string } | null
  const { currentContractId } = useCurrentContract()

  const backPath =
    locationState?.from === 'contact'
      ? routePath.contactInfo.replace(':contractId', currentContractId)
      : frontPagePath

  const backText =
    locationState?.from === 'contact'
      ? t('titles:contactInformation')
      : t('common:views.home')

  return (
    <TitleController title={t('feedback:headings.feedback')}>
      <ResidentAppView
        title={t('feedback:headings.feedback')}
        backLink={
          <ResidentAppBackLink href={backPath}>{backText}</ResidentAppBackLink>
        }
        aside={
          <ResidentAppAsideText>
            {t('feedback:texts.instructions')}
          </ResidentAppAsideText>
        }
      >
        <ResidentAppCard>
          <FeedbackDataLoader>
            {({ contract, user, userMetadata }) =>
              view === 'success' ? (
                <FeedbackSuccess />
              ) : (
                <FeedbackForm
                  contract={contract}
                  user={user}
                  userMetadata={userMetadata}
                  view={view}
                  setView={setView}
                />
              )
            }
          </FeedbackDataLoader>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
